export default __webpack_public_path__ + "static/media/quotation.6b460e30.svg";